import { Sparkles } from 'lucide-react'

type Props = {
  count:       number
  onPlanMeals: () => void
}

export function ExpiringNudge({ count, onPlanMeals }: Props) {
  if (count < 1) return null

  return (
    <div className="mb-5 flex items-center gap-3 rounded-[18px] bg-[#FBE8DB] px-4 py-[14px]">
      <div
        className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-[14px]"
        style={{ background: 'var(--terracotta)' }}
      >
        <Sparkles className="h-5 w-5" style={{ color: 'var(--cream)' }} strokeWidth={1.6} />
      </div>
      <div className="flex-1">
        <div className="font-serif text-[15px] font-medium leading-tight text-ink">
          {count} {count === 1 ? 'item' : 'items'} expiring soon
        </div>
        <div className="mt-0.5 text-[11px] text-[#7A5A3A]">
          Get meal ideas before they go to waste
        </div>
      </div>
      <button
        onClick={onPlanMeals}
        className="rounded-[10px] px-[14px] py-2 text-[11px] font-semibold"
        style={{ background: 'var(--forest)', color: 'var(--forest-ink)' }}
      >
        Plan
      </button>
    </div>
  )
}
